module.exports = "<p>\n  order works!\n</p>\n<router-outlet></router-outlet>"